<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <ProductComparison :isPublic="false"></ProductComparison>
    </div>
</template>

<script>
    import ProductComparison from "../../components/parametric-search/ProductComparison"

    export default {
        name: "MyParametricCompare",
        components: {
            ProductComparison
        }
    }
</script>
